import React from 'react';
import Link from "next/link";

const CompanyFAQMenuItem = ({ title, link, onClick }) => {
  return (
    <Link href={`#${link}`} onClick={onClick} className="list-group-item list-group-item-action py-3 text-reset">
      {title}
    </Link>
  );
};

export default CompanyFAQMenuItem;
